import React, { useEffect, FC, useContext } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
// selectors
import { useConfigSelectors, useFilterDataSelectors } from 'src/app/reducers';
import { useSortSelectors, useFilterSelectors } from 'src/@noiseEvents/reducers';
import { NoiseEventsDispatchContext } from 'src/@noiseEvents/providers/NoiseEventsStateProvider';
// actions
import {
  fetchData,
  initialiseFilterStore,
  resetAndFetchData,
  fetchNoiseMonitorData,
} from 'src/@noiseEvents/actions';
// stores
import { dateRangeStore } from 'src/app/stores/dateRangeStore';
// utils
import { screenScrollToTop } from 'src/utils';
// interfaces
import { IDataContainer } from 'src/@noiseEvents/interfaces';

export const DataContainer: FC<IDataContainer> = ({ children, correlatedIds = [] }) => {
  const client = useApolloClient();
  const dispatcher = useContext(NoiseEventsDispatchContext);
  // Configuration
  const configSelectors = useConfigSelectors();
  const {
    grid: { resultSize },
  } = configSelectors.getConfig();

  const sortSelectors = useSortSelectors();
  const sortString = sortSelectors.getSortString();
  const filterSelectors = useFilterSelectors();
  const filterString = filterSelectors.getFilterString();
  const isInitialised = filterSelectors.getIfInitialised();

  // filters data
  const filtersSelectors = useFilterDataSelectors();
  const operationFilterData = filtersSelectors.getOperationsFilterData();
  const classificationGroups = filtersSelectors.getNoiseEventsFilterData().classificationGroups;
  const { from, to } = dateRangeStore.getDatesStrings();

  useEffect(() => {
    if (isInitialised) {
      resetAndFetchData(client, resultSize, dispatcher, sortString, filterString);
    }
  }, [filterString, sortString, from, to]);

  useEffect(() => {
    screenScrollToTop();
  }, []);

  useEffect(() => {
    if (isInitialised) {
      fetchData({ client, resultSize, newDispatcher: dispatcher, sortString, filterString });
      fetchNoiseMonitorData(client, dispatcher, operationFilterData.airportIds);
    } else {
      initialiseFilterStore(dispatcher, classificationGroups, correlatedIds);
    }
  }, [isInitialised]);

  return <>{children}</>;
};
